
import { defineComponent } from "vue";

import works from "@/fixtures/works";
import WorkItem from "@/components/SelectedWork/WorkItem/WorkItem.vue";
import { Work } from "@/interfaces/work";

export default defineComponent({
  name: "WorkItems",
  components: {
    WorkItem,
  },
  setup(props, { emit }) {
    const openModal = (work: Work) => {
      emit("updateModal", true, work);
    };

    return {
      works,
      openModal,
    };
  },
});
